import React, { useEffect, useState } from "react";
import "./Service.css";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";

import { FiLayers, FiUsers, FiEye } from "react-icons/fi";

const Service = () => {
  const navigate = useNavigate();
  const [vendorCategories, setVendorCategories] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10, totalCategories: 0, totalVendors: 0 });



  /* ================= FETCH DATA ================= */

  useEffect(() => {
    fetchVendorCategories();
  }, []);

  useEffect(() => {
    fetchVendorCategories();
  }, [pagination.page]);

  const fetchVendorCategories = async () => {
    try {
      const res = await api.get(`/listing/vendor-under/categories?page=${pagination.page}&limit=${pagination.limit}`);
      if (res.data?.success) {
        setVendorCategories(res.data.data || []);
      setPagination(prev => ({
  ...prev,
  totalCategories: res.data.pagination?.totalCategories || 0,
  totalVendors: res.data.pagination?.totalVendors || 0
}));
      }
    } catch (err) {
      console.error("Failed to fetch vendor categories:", err);
    }
  };








  /* ================= UI ================= */

  return (
    <div className="service-page">
      {/* ===== STATS ===== */}
      <div className="service-stats">
        <div className="stat-card">
          <div className="stat-icon agent-icon">
            <FiUsers />
          </div>
          <div className="stat-info">
            <span className="stat-label">Total Categories</span>
            <span className="stat-value">{pagination.totalCategories}</span>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon leads"><FiLayers /></div>
          <div className="stat-info">
            <span className="stat-label">Total Vendors</span>
            <span className="stat-value">{pagination.totalVendors}</span>
          </div>
        </div>
      </div>



      {/* ===== VENDOR CATEGORIES TABLE ===== */}
      <div className="service-section">
        <div className="section-header">
          <h3>Categories with Vendors</h3>
        </div>

        <div className="service-table">
          <table>
            <thead>
              <tr>
                <th>S no.</th>
                <th>Category</th>
                <th>Vendor Count</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {vendorCategories.map((item, i) => (
                <tr key={item.categoryId}>
                  <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                  <td>{item.category}</td>
                  <td>{item.vendors?.length || 0}</td>
                  <td>
                    <button 
                      className="view-btn"
                      onClick={() => navigate(`/vendor-list/${item.categoryId}`, { state: { categoryName: item.category, vendors: item.vendors } })}
                    >
                      <FiEye /> View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {pagination.totalCategories > pagination.limit && (
          <div className="pagination">
            <button
              onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
              disabled={pagination.page === 1}
            >
              Previous
            </button>
            <span>Page {pagination.page} of {Math.ceil(pagination.totalCategories / pagination.limit)}</span>
            <button
              onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
              disabled={pagination.page >= Math.ceil(pagination.totalCategories / pagination.limit)}
            >
              Next
            </button>
          </div>
        )}
      </div>




    </div>
  );
};

export default Service;
